var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7336_12532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.002 6C15.792 6 19.172 8.13 20.822 11.5C19.172 14.87 15.792 17 12.002 17C8.21195 17 4.83195 14.87 3.18195 11.5C4.83195 8.13 8.21195 6 12.002 6ZM12.002 4C7.00195 4 2.73195 7.11 1.00195 11.5C2.73195 15.89 7.00195 19 12.002 19C17.002 19 21.272 15.89 23.002 11.5C21.272 7.11 17.002 4 12.002 4ZM12.002 9C13.382 9 14.502 10.12 14.502 11.5C14.502 12.88 13.382 14 12.002 14C10.622 14 9.50195 12.88 9.50195 11.5C9.50195 10.12 10.622 9 12.002 9ZM12.002 7C9.52195 7 7.50195 9.02 7.50195 11.5C7.50195 13.98 9.52195 16 12.002 16C14.482 16 16.502 13.98 16.502 11.5C16.502 9.02 14.482 7 12.002 7Z",
    fill: "#BDBDBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7336_12532"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.00195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionView);
export default __webpack_public_path__ + "static/media/action_view.8bdc4548e7f2f407a439b4278c7cb8ce.svg";
export { ForwardRef as ReactComponent };